import parser from 'ua-parser-js';
import { Logger as SeqLogger } from '../../temp/seq-logging';
import clientConf from './seq-logger-client-conf.json';

const logger = new SeqLogger(clientConf);

const uaString = window.navigator.userAgent;
const ua = parser(uaString);

export default {
  close: () => logger.close(),
  emit: ({ messageTemplate, level = 'Debug', properties }) => {
    if (process.env.NODE_ENV === 'development') {
      return;
    }

    logger.emit({
      timestamp: new Date(),
      level,
      messageTemplate,
      properties: {
        ...properties,
        ApplicationHost: window.location.host,
        RequestPath: window.location.href,
        Path: window.location.pathname,
        UserDevice: ua.device,
        UserBrowser: ua.browser,
        UserOS: ua.os,
        Client: 'VM2 - quick fix'
      }
    });
  }
};
